module.exports = __webpack_public_path__ + "img/5left-n-508bc35b.png";